import { ThemeParameters, RuntimeThemeParameters } from '../../types';
import { graphDefault } from './';

export const graphBackFill = (theme: ThemeParameters, parameters: RuntimeThemeParameters) => {
  return {
    fillColor: graphDefault(theme, parameters).backgroundColor,
    frameBorder: false,
  };
};
